/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Cps_Exceeds_HintInputs */

const en_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend duration of Event, or reduce text content.`)
};

const fr_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allongez la duree de l'evenement ou reduisez le texte.`)
};

const de_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlängern Sie die Dauer des Ereignisses oder reduzieren Sie den Textinhalt.`)
};

const it_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estendi la durata dell'evento o riduci il contenuto del testo.`)
};

const ru_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличьте продолжительность мероприятия или сократите текстовое содержимое.`)
};

const es_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar la duración del evento o reducir el contenido del texto.`)
};

const zh_cn2_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`延长活动持续时间，或减少文本内容。`)
};

const ja_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの期間を延長するか、テキストコンテンツを減らします。`)
};

const hi_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की अवधि बढ़ाएं या टेक्स्ट की मात्रा कम करें।`)
};

const pt_pt2_error_nav_cps_exceeds_hint = /** @type {(inputs: Error_Nav_Cps_Exceeds_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prolongue a duração do evento ou reduza o conteúdo do texto.`)
};

/**
* | output |
* | --- |
* | "Extend duration of Event, or reduce text content." |
*
* @param {Error_Nav_Cps_Exceeds_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_cps_exceeds_hint = /** @type {((inputs?: Error_Nav_Cps_Exceeds_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Cps_Exceeds_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_cps_exceeds_hint(inputs)
	if (locale === "de") return de_error_nav_cps_exceeds_hint(inputs)
	if (locale === "it") return it_error_nav_cps_exceeds_hint(inputs)
	if (locale === "ru") return ru_error_nav_cps_exceeds_hint(inputs)
	if (locale === "es") return es_error_nav_cps_exceeds_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_cps_exceeds_hint(inputs)
	if (locale === "ja") return ja_error_nav_cps_exceeds_hint(inputs)
	if (locale === "hi") return hi_error_nav_cps_exceeds_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_cps_exceeds_hint(inputs)
	return en_error_nav_cps_exceeds_hint(inputs)
});